import { useEffect, useState } from "react";
import { api } from "../lib/api";

/** Full output of a workflow/projection stage. The detail frame ships a ±300-char snippet (`output_snippet`, `output_chars`); the full text is fetched when the stage opens. */
export function useStepOutput(taskId, step, open) {
  const [full, setFull] = useState(null);
  const [loading, setLoading] = useState(false);
  const sid = step?.id || (step?.part_n != null ? `part-${step.part_n}` : null);
  const needsFetch = !!step && step.output == null && (step.output_chars || 0) > 0;
  useEffect(() => { setFull(null); }, [sid, step?.output_chars]);
  useEffect(() => {
    if (!open || !needsFetch || full != null || !sid || !taskId) return undefined;
    let alive = true;
    setLoading(true);
    api.get(`/tasks/${taskId}/steps/${sid}/output`).then((r) => { if (alive) setFull(r.data.output || ""); }).catch(() => { if (alive) setFull(""); }).finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [open, needsFetch, full, sid, taskId]);
  return { output: step?.output ?? full, snippet: step?.output_snippet || "", hasOutput: !!(step?.output || (step?.output_chars || 0) > 0), loading };
}
